import type { TenantConfig } from '@/types/TenantConfig'

const gray = '#212121'

export const thediscoasis: TenantConfig = {
  logo: 'assets/thediscoasis/static/logo4.png',
  teaserImageSize: {
    width: 272,
    height: 216,
  },
  themeMode: 'dark',
  themeOptions: {
    backButton: {
      backgroundColor: '#ffffff',
      iconColor: '#282B37',
    },
    dialog: {
      backgroundColor: gray,
      headerBackground: gray,
      headerTextColor: 'white',
      headerIconColor: 'white',
      headerBorder: '1px solid #434343',
    },
    mobileFooter: {
      backgroundColor: gray,
      textColor: 'white',
      cartButtonBackgroundColor: 'transparent',
      cartButtonHoverBackgroundColor: 'transparent',
      cartButtonBorder: '2px solid white',
      cartButtonIconColor: 'white',
      priceTextColor: 'white',
    },
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: '/assets/thediscoasis/static/fonts.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/thediscoasis/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-155px',
        mobile: '-140px',
      },
    },
  },
}
